import { Text } from '@belong/ui';
import { POST_INSPECTION_FLOW_STRINGS } from 'strings/post-inspection-flow';

export function WalkthroughExplainer() {
  return (
    <div className="mb-3xl rounded border border-solid border-green bg-[#fbfffc] p-[20px]">
      <Text fontWeight="semibold" className="mb-xs">
        {POST_INSPECTION_FLOW_STRINGS['intro.explainer.title']}
      </Text>
      <Text variant="p1">
        {POST_INSPECTION_FLOW_STRINGS['intro.explainer.body']}
      </Text>
    </div>
  );
}
